// extracted by mini-css-extract-plugin
export default {"popup":"G2v3r","container":"gioIw","iconClose":"uikEf","wrapperImage":"PFdm_","img":"aoaSC","iconPlay":"B4wfa","content":"ZvFaT","title":"usRTB AawBX","text":"dIG24"};